let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gQOEB")).then(() => parcelRequire('4x6ob'));